import styled from "styled-components";

export const FormFieldContainer = styled.div`
  max-width: 700px;
`;
